import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NotificationItem } from '@ps/notification-models';

import {
  NotificationActionApplyResult,
  NotificationActionLiveState,
} from './notification.model';

export interface NotificationActionCommandProps {
  notificationId: string;
  surveyId: string;
  commentId: string;
  actionId: string;
}

export const NotificationActions = createActionGroup({
  source: 'Notification',
  events: {
    Refresh: emptyProps(),
    'Invalidate Cache': emptyProps(),
    'Load Notifications': emptyProps(),
    'Load Unseen Count': emptyProps(),
    'Mark All Viewed': emptyProps(),
    'Mark Viewed': props<{ notificationId: string; viewed: boolean }>(),
    'Apply Action': props<NotificationActionCommandProps>(),
    'Undo Action': props<NotificationActionCommandProps>(),
  },
});

export const NotificationApiActions = createActionGroup({
  source: 'Notification API',
  events: {
    'Load Notifications Started': emptyProps(),
    'Load Notifications Success': props<{
      notifications: NotificationItem[];
      cachedAt: number;
    }>(),
    'Load Notifications Failure': props<{ error: string }>(),
    'Load Unseen Count Success': props<{
      unseenCount: number;
      communicationCount: number | null;
      needsActionCount: number | null;
      cachedAt: number;
    }>(),
    'Load Unseen Count Failure': props<{ error: string }>(),
    'Mark All Viewed Success': props<{ changed: number }>(),
    'Mark All Viewed Failure': props<{ error: string }>(),
    'Mark Viewed Success': props<{ notification: NotificationItem }>(),
    'Mark Viewed Failure': props<{ error: string }>(),
    'Apply Action Success': props<{
      notificationId: string;
      actionId: string;
      result: NotificationActionApplyResult;
    }>(),
    'Apply Action Failure': props<{ notificationId: string; error: string }>(),
    'Undo Action Success': props<{
      notificationId: string;
      actionId: string;
      result: NotificationActionApplyResult;
    }>(),
    'Undo Action Failure': props<{ notificationId: string; error: string }>(),
    'Load Action States Success': props<{
      states: NotificationActionLiveState[];
    }>(),
  },
});
